import { render } from "./TableFormBlocks.vue?vue&type=template&id=585cddee&scoped=true"
import script from "./TableFormBlocks.vue?vue&type=script&lang=js"
export * from "./TableFormBlocks.vue?vue&type=script&lang=js"

import "./TableFormBlocks.vue?vue&type=style&index=0&id=585cddee&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585cddee"]])

export default __exports__